<template>
  <div class="relative w-full">
    <div
      class="w-full px-3 py-2 border border-n-weak rounded-md bg-white dark:bg-n-solid-1 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 cursor-pointer"
      @click="toggleDropdown"
    >
      <div class="flex items-center justify-between gap-2">
        <span :class="modelValue ? 'text-sm text-n-slate-12 truncate' : 'text-n-slate-11 truncate'">
          {{ modelValue || placeholder }}
        </span>
        <button
          v-if="modelValue"
          type="button"
          class="text-n-slate-11 hover:text-n-slate-12 text-lg leading-none"
          @click.stop="clearSelection"
        >
          ×
        </button>
        <svg v-else class="w-4 h-4 text-n-slate-11 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>

    <div
      v-if="showDropdown"
      class="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-n-solid-1 border border-n-weak rounded-md shadow-lg z-50 max-h-80 overflow-hidden"
    >
      <div class="p-2 border-b border-n-weak">
        <input
          ref="searchInput"
          v-model="searchQuery"
          type="text"
          :placeholder="searchPlaceholder"
          class="w-full px-3 py-2 border border-n-weak rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-n-solid-2 text-sm"
          @input="onSearch"
          @keydown.escape="closeDropdown"
        />
      </div>

      <div class="max-h-60 overflow-y-auto">
        <div v-if="loading" class="p-4 text-center text-n-slate-11 text-sm">
          Cargando...
        </div>
        <div v-else-if="filteredOptions.length === 0" class="p-4 text-center text-n-slate-11 text-sm">
          Sin resultados
        </div>
        <div
          v-for="opt in filteredOptions"
          v-else
          :key="opt.id"
          class="px-3 py-2 text-sm cursor-pointer hover:bg-n-slate-2 dark:hover:bg-n-solid-3 border-b border-n-weak last:border-b-0"
          :class="{ 'bg-n-brand/5': opt.id === modelValue }"
          @click="selectOption(opt)"
        >
          {{ opt.name }}
        </div>
      </div>
    </div>

    <div v-if="showDropdown" class="fixed inset-0 z-40" @click="closeDropdown" />
  </div>
</template>

<script>
export default {
  name: 'SearchableValueSelect',
  props: {
    modelValue: { type: [String, Number], default: '' },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: 'Seleccionar valor' },
    searchPlaceholder: { type: String, default: 'Buscar...' },
    loading: { type: Boolean, default: false },
    // Cuando true la búsqueda la resuelve el padre (server-side): no filtra local
    serverSearch: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'search'],
  data() {
    return { showDropdown: false, searchQuery: '' };
  },
  computed: {
    filteredOptions() {
      if (this.serverSearch || !this.searchQuery) return this.options;
      const q = this.searchQuery.toLowerCase();
      return this.options.filter(o => String(o.name).toLowerCase().includes(q));
    },
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
      if (this.showDropdown) {
        this.searchQuery = '';
        this.$nextTick(() => this.$refs.searchInput?.focus());
      }
    },
    closeDropdown() {
      this.showDropdown = false;
      this.searchQuery = '';
    },
    onSearch() {
      this.$emit('search', this.searchQuery);
    },
    selectOption(opt) {
      this.$emit('update:modelValue', opt.id);
      this.closeDropdown();
    },
    clearSelection() {
      this.$emit('update:modelValue', '');
    },
  },
};
</script>
